export default __webpack_public_path__ + "static/media/uploader-dexcom-1.e76e0b26.png";